/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * A criterion as the UI currently holds it. ``id`` is the client's local
 * id (drafts are not persisted until launch); proposed deltas echo it back.
 */
export interface ModifyCriterionDraft {
  /**
     * @minLength 1
     * @maxLength 100
     */
  id: string;
  /** @maxLength 200 */
  label?: string;
  /** @maxLength 2000 */
  description?: string;
  position?: number;
}
